enum ServiceResponseResult {
    Successful = 1,
    Failed = 2,
};

export { ServiceResponseResult };
